import './index.scss'
$("header .nav li").eq(6).addClass("active");